<template>
	<div>
		<div
			class="task task--parent"
			:class="{'task--owned':userIsOwner}">
			<div
				class="task__cell task__open-children" v-if="task.ChildTasks">
				<button type="button" class="task__open-children__button" @click="toggleChildTasks"
					:class="{'task__open-children__button--due':due}">
					<i v-if="!childTasksOpen" class="fas fa-chevron-circle-right"></i>
					<i v-else class="fas fa-chevron-circle-down"></i>
				</button>
			</div>
			<div
				class="task__cell task__done"
				:class="{'task__done--due':due}"
				v-if="!task.ChildTasks">
				<span v-if="userIsOwner">
					<i v-if="task.Info.done" class="far fa-check-circle" @click="toggleTask(!task.Info.done)"></i>
					<i v-else class="far fa-circle"	@click="toggleTask(!task.Info.done)"></i>
				</span>
			</div>
			<div class="task__cell task__type">
				{{task.type}}
			</div>
			<div class="task__cell task__description">
				{{task.description}}
			</div>
			<div class="task__cell task__topic" v-if="$mq === 'lg'">
				<span v-if="topic">{{topic.title}}</span>
			</div>
			<div class="task__cell task__day" v-if="!(weekView === 'byDay' && pageIsWeek) && $mq === 'lg'">
				{{getDayName(task.Info.date)}}
			</div>
		</div>
		<div class="task__children" v-if="task.ChildTasks" ref="children" :style="{'height': childTasksHeight}">
			<div class="task__children__content" ref="childrenContent">
				<ChildTask v-for="childTask in task.ChildTasks" :key="childTask.id" :childTask="childTask" :planningId="task.planningId">
				</ChildTask>
			</div>
		</div>
	</div>
</template>

<script>
import DateService from '@/services/DateService'
import ChildTask from '@/components/ChildTask'
export default {
	components: { ChildTask },
	props: {
		task: Object,
		topic: Object,
		// Page
		pageIsWeek: Boolean
	},
	data () {
		return {
			childTasksOpen: false,
			childTasksHeight: 0
		}
	},
	methods: {
		async toggleTask (done) {
			// Check if task should be toggled
			if (!this.userIsOwner) return
			// Dispatch toggleTask action so the store's data is updated
			this.$store.dispatch('toggleTask', {
				planningId: this.task.planningId,
				taskId: this.task.id,
				done
			})
		},
		getDayName (date) {
			return DateService.getDayName(date)
		},
		toggleChildTasks () {
			if (this.task.ChildTasks) {
				this.childTasksHeight = this.childTasksOpen ? 0 : this.$refs.childrenContent.clientHeight + 'px'
			}
			this.childTasksOpen = !this.childTasksOpen
		}
	},
	computed: {
		planning () {
			const index = this.$store.state.plannings.findIndex(planning => planning.id === this.task.planningId)
			return this.$store.state.plannings[index]
		},
		userIsOwner () {
			if (!this.planning) return false
			return this.planning.User.id === this.$store.state.authentication.user.id
		},
		due () {
			const date = new Date()
			if (new Date(this.task.Info.date) >= date) return false
			if (this.task.ChildTasks) {
				let done = true
				this.task.ChildTasks.forEach(childTask => { if (!childTask.Info.done) done = false })
				return !done
			}
			return !this.task.Info.done
		},
		weekView () {
			return this.$store.state.settings.weekView
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_task.scss"
</style>
